import { AsyncMultiSelectDropdown } from 'ui-builder';
import { usePlansAdminService } from 'nekst-api';
import React from 'react';
import { PlansMultiDropdownProps } from './PlansMultiDropdown';

export function GlobalPlansMultiDropdown(
  props: PlansMultiDropdownProps
) {
  const plansService = usePlansAdminService();

  return (
    <AsyncMultiSelectDropdown
      {...props}
      loadOptionsFunc={async () => {
        let plans = await plansService.getAllGlobalPlans();

        if (props.exceptPlansIds) {
          plans = plans.filter(
            (plan) => !props.exceptPlansIds!.includes(plan.id),
          );
        }

        return plans.map(
          (plan) => ({
            value: plan.id,
            label: `${plan._setupArea?.name} / ${plan.name}`,
          }),
        );
      }}
    />
  );
}
